export const SlackSymbol = Symbol('slack');
